import { render, staticRenderFns } from "./PokemonFavoritos.vue?vue&type=template&id=73da200f&scoped=true&"
import script from "./PokemonFavoritos.vue?vue&type=script&lang=js&"
export * from "./PokemonFavoritos.vue?vue&type=script&lang=js&"
import style0 from "./PokemonFavoritos.vue?vue&type=style&index=0&id=73da200f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73da200f",
  null
  
)

export default component.exports